import * as yup from 'yup'
import { defineMessages, IntlShape } from 'react-intl'

const messages = defineMessages({
  requiredCompany: {
    id: 'addonService.form.company.required',
    defaultMessage: 'The company is required'
  },
  requiredCompanyLine: {
    id: 'addonService.form.companyLine.required',
    defaultMessage: 'The company line is required'
  },
  requiredSalesChannels: {
    id: 'addonService.form.salesChannels.required',
    defaultMessage: 'You need to select at least one valid sales channel'
  },
  requiredConfirmationModalities: {
    id: 'addonService.form.confirmationModalities.required',
    defaultMessage: 'You need to select at least one valid confirmation modality'
  },
  requiredSegments: {
    id: 'addonService.form.segments.required',
    defaultMessage: 'You need to select at least one valid segment'
  },
  requiredTicketFees: {
    id: 'addonService.form.ticketFees.required',
    defaultMessage: 'Fee is required'
  }
})

export const schema = (intl: IntlShape): unknown => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.requiredCompany))
    }),
    companyLine: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.requiredCompanyLine))
    }),
    salesChannels: yup.array().min(1, intl.formatMessage(messages.requiredSalesChannels)),
    confirmationModalities: yup.array().min(1, intl.formatMessage(messages.requiredConfirmationModalities)),
    segments: yup.array().min(1, intl.formatMessage(messages.requiredSegments)),
    ticketFees: yup.array().of(
      yup.object().shape({
        fees: yup.array().of(
          yup.object().shape({
            amount: yup.number().required(intl.formatMessage(messages.requiredTicketFees))
          })
        )
      })
    )
  })
}
